export default {"src":"/_next/static/media/transit-score.b367e7a2.svg","height":77,"width":77,"blurWidth":0,"blurHeight":0};